import React from "react";
import { Card, CardHeader, CardBody, Table } from "reactstrap";

const Badge = ({ text, color }) => (
  <span
    style={{
      background: `rgba(${color},0.15)`,
      color: `rgb(${color})`,
      fontSize: "11px",
      padding: "4px 10px",
      borderRadius: "999px",
      fontWeight: "600",
      letterSpacing: "0.4px"
    }}
  >
    {text}
  </span>
);

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const pageIconWrapStyle = {
  width: 32,
  height: 32,
  borderRadius: 8,
  border: "1px solid rgba(var(--vz-primary-rgb), 0.35)",
  background: "rgba(var(--vz-primary-rgb), 0.08)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const pageIconStyle = {
  color: "var(--vz-primary)",
  fontSize: 16,
};

const ICSVulnerabilityMonitoring = () => {
  return (
    <Card style={{ ...cardShell, border: "1px solid rgba(255,255,255,0.05)" }} className="h-100">

      <CardHeader className="bg-light">
        <h5 className="card-title mb-0">
          <div style={pageIconWrapStyle} className="me-2">
            <i className="ri-shield-keyhole-line" style={pageIconStyle} ></i>
          </div>

          ICS Vulnerability Monitoring
        </h5>
      </CardHeader>

      <CardBody>

        <p className="text-muted mb-3">
          High severity industrial assets with known CVE exposure.
        </p>

        <Table className="table-borderless align-middle">
          <thead>
            <tr className="text-muted">
              <th>Industrial Device</th>
              <th>CVE Identifier</th>
              <th>Severity</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>

            <tr>
              <td>Allen Bradley Logix 5571</td>
              <td>CVE-2023-3595</td>
              <td>
                <Badge text="CRITICAL" color="239,68,68" />
              </td>
              <td>Unpatched</td>
            </tr>

            <tr>
              <td>Schneider Electric Modicon</td>
              <td>CVE-2022-45788</td>
              <td>
                <Badge text="CRITICAL" color="239,68,68" />
              </td>
              <td>In Progress</td>
            </tr>

            <tr>
              <td>Siemens Scalance Switch</td>
              <td>CVE-2021-33723</td>
              <td>
                <Badge text="HIGH" color="250,204,21" />
              </td>
              <td>Pending</td>
            </tr>

            <tr>
              <td>Emerson DeltaV Controller</td>
              <td>CVE-2023-2189</td>
              <td>
                <Badge text="CRITICAL" color="239,68,68" />
              </td>
              <td>Exploitable</td>
            </tr>

            <tr>
              <td>Honeywell Experion PKS</td>
              <td>CVE-2022-2051</td>
              <td>
                <Badge text="HIGH" color="250,204,21" />
              </td>
              <td>Pending</td>
            </tr>

          </tbody>
        </Table>

      </CardBody>
    </Card>
  );
};

export default ICSVulnerabilityMonitoring;